module.exports = __webpack_public_path__ + "static/media/cctv3.4eba31ce.png";